import { from, of } from "rxjs"
import { ofType } from "redux-observable"
import { switchMap, catchError } from "rxjs/operators"
import { push } from "connected-react-router"

import {
    fetchAllDataSuccess,
    createNewPlanSuccess,
    fetchAllPlans as fetchAllPlansAction,
    fetchAllPlansSuccess,
    fetchPlanForEditSuccess,
    updatePlanSuccess,
} from "./actions"

import * as errorActions from "../error/actions"

import { hideLoader } from "../loader/actions"
import { showNotification } from "../notification/actions"
import planApi from "../../api/plan-api"
import * as types from "./actionTypes"
import { labels } from "../../constants/labels"
import ValidationMessage from "../../constants/messages/messages"

export function fetchAllData(action$) {
    return action$.pipe(
        ofType(types.FETCH_ALL_DATA),
        switchMap((action) =>
            from(planApi.getAllData(action.payload)).pipe(
                switchMap((data) =>
                    of(
                        fetchAllDataSuccess(
                            data.data[0].configData.EQUIPMENT_TYPE
                        ),
                        hideLoader()
                    )
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function crateNewPlan(action$) {
    return action$.pipe(
        ofType(types.CREATE_NEW_PLAN),
        switchMap((action) =>
            from(planApi.createNewPlan(action.payload)).pipe(
                switchMap((response) =>
                    of(
                        createNewPlanSuccess(),
                        fetchAllPlansAction(),
                        hideLoader(),
                        showNotification({
                            show: true,
                            message: `${labels.planLbl.plan} "${response?.planName?.trim()}" ${
                                labels.planLbl.planSuccessMsg
                            } `,
                            alertType: "success",
                        })
                    )
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function fetchAllPlans(action$) {
    return action$.pipe(
        ofType(types.FETCH_ALL_PLANS),
        switchMap((action) =>
            from(planApi.getAllPlans(action.payload)).pipe(
                switchMap((plans) =>
                    of(fetchAllPlansSuccess(plans), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function fetchPlanForEdit(action$) {
    return action$.pipe(
        ofType(types.FETCH_PLAN_EDIT),
        switchMap((action) =>
            from(planApi.getPlan(action.payload)).pipe(
                switchMap((plans) =>
                    of(fetchPlanForEditSuccess(plans), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function updatePlan(action$) {
    return action$.pipe(
        ofType(types.UPDATE_PLAN),
        switchMap((action) =>
            from(planApi.updatePlan(action.payload)).pipe(
                switchMap((response) =>
                    of(
                        updatePlanSuccess(),
                        fetchAllPlansAction(),
                        hideLoader(),
                        showNotification({
                            show: true,
                            message: `${labels.planLbl.plan} "${response?.planName?.trim()}" ${
                                labels.common.successfullyUpdated
                            } `,
                            alertType: "success",
                        })
                    )
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function setDefaultPlan(action$) {
    return action$.pipe(
        ofType(types.SET_DEFAULT_PLAN),
        switchMap((action) =>
            from(
                planApi.putPlanDefault(
                    action.payload.data,
                    action.payload.planCategory
                )
            ).pipe(
                switchMap(() =>
                    of({
                        type: types.FETCH_ALL_PLANS,
                    })
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function deletePlan(action$) {
    return action$.pipe(
        ofType(types.DELETE_PLAN),
        switchMap((action) =>
            from(planApi.deleteExistingPlan(action.payload)).pipe(
                switchMap(() =>
                    of(
                        showNotification({
                            show: true,
                            message: ValidationMessage.forPlanDeleted(
                                action.payload
                            ),
                            alertType: "success",
                        }),
                        fetchAllPlansAction()
                    )
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}
